import React from "react";
import { Helmet } from "react-helmet";

const ผู้รับพินัยกรรม = () => {
  const TITLE = "ความสามารถของผู้รับพินัยกรรม";

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>

      <div className="content">
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ความสามารถของผู้รับพินัยกรรม
          จะพิจารณาได้เฉพาะในเวลาที่ผู้ทำพินัยกรรมถึงแก่ความตายเท่านั้น
          จึงจะมีสิทธิตามพินัยกรรม แล้วใครสามารถเป็นผู้รับพินัยกรรมได้บ้าง
          สามารถแยกพิจารณาได้หัวข้อต่อไปนี้ คือ ประเภทของผู้รับพินัยกรรม
          และบุคคลที่ห้ามรับมรดกตามพินัยกรรม
        </p>

        {/* 1. ประเภทของผู้รับพินัยกรรม */}
        <div>
          <h2 id="initial-header">1. ประเภทของผู้รับพินัยกรรม</h2>
          <p>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;การที่ต้องพิจารณาผู้รับพินัยกรรมนั้น
            เพราะว่าผู้ทำพินัยกรรมได้ทำพินัยกรรมไว้เป็นคำสั่งในรูปแบบของพินัยกรรมประเภทต่าง
            ๆ ตามที่ผู้ทำพินัยกรรมได้ทำไว้ โดยประเภทของผู้รับพินัยกรรม
            แบ่งออกเป็น 2 ประเภทดังนี้
            <ul className=" list-decimal ml-16 mt-3">
              <li>
                ถ้า
                <mark className=" bg-[#fee9b2] rounded-xl">
                  ผู้ทำพินัยกรรมไม่ได้ระบุทรัพย์สินที่เจาะจงเอาไว้แก่ผู้รับพินัยกรรม
                </mark>
                แต่ในภายหลังพบว่า ผู้ทำพินัยกรรม มีทรัพย์สินมรดกอย่างอื่นอีก
                ในกรณีนี้ผู้รับพินัยกรรมย่อมมีสิทธิได้รับมรดกอย่างอื่นด้วย
                เพราะผู้ทำพินัยกรรม ไม่ได้ระบุไว้ว่า
                ผู้รับพินัยกรรมบุคคลนี้ต้องได้รับทรัพย์มรดกชิ้นไหน
                หรือส่วนไหนนั้นเอง <br />
                <b>
                  ผู้รับพินัยกรรมประเภทนี้ เรียกว่า
                  'ผู้รับพินัยกรรมลักษณะทั่วไป'
                </b>
              </li>
              <li>
                ถ้า
                <mark className=" bg-[#fee9b2] rounded-xl">
                  ผู้รับพินัยกรรมได้รับุทรัพย์สินที่เจาะจงเอาไว้
                  หรือแยกไว้ต่างหากจากกองมรดกให้แก่ผู้รับพินัยกรรม
                </mark>
                แต่ในภายหลังผู้ทำพินัยกรรมมีทรัพย์สินอย่างอื่น
                ในกรณีผู้รับพินัยกรรมย่อมไม่มีสิทธิได้รับมรดกอย่างอื่น
                เพราะผู้ืำพินัยกรรมได้ระบุหรือเจาะจงทรัพย์มรดกให้แก่ผู้รับพินัยกรรมแล้วว่าต้องได้รีบทรัพย์มรดกชิ้นไหน
                หรือส่วนไหนนั้นเอง <br />
                <b>
                  {" "}
                  ผู้รับพินัยกรรมประเภทนี้ เรียกว่า 'ผู้รับพินัยกรรมลักษณะเฉพาะ'
                </b>
              </li>
            </ul>
          </p>
        </div>

        {/* 2. บุคคลที่ห้ามรับทรัพย์มรดกตามพินัยกรรม */}
        <h2 id="second-header">2. บุคคลที่ห้ามรับทรัพย์มรดกตามพินัยกรรม</h2>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;บุคคลที่ห้ามรับมรดก
          ถ้าบุคคลนั้นเป็นผู้รับพินัยกรรมในลักษณะดังนี้
          <ul className=" list-decimal ml-16 mt-3">
            <li>
              <mark className=" bg-[#fee9b2] rounded-xl">
                ห้ามบุุคคลที่อยู่ในความปกครอง
              </mark>{" "}
              เช่น คนเสมือนไร้คววามสามารถ
              <mark className=" bg-[#fee9b2] rounded-xl">
                ทำพินัยกรรมยกทรัพย์มรดกให้แก่ผู้ปกครองตนเอง
              </mark>{" "}
              โดยผู้ปกครองนี้จะไม่รวมถึง บิดา
              มารดาของบุคคลที่อยู่ในความปกครองนั้น
              แต่ถ้าความปกครองนั้นได้สิ้นสุดลงแล้ว
              และผู้ปกครองของบุคคลที่อยู่ในความปกครองนั้นได้ทำคำแถลงการณ์ปกครองเสร็จสิ้นแล้ว
              บุคคลที่อยู่ในความปกครองนั้นสามารถทำพินัยกรรมยกกทรัพย์มรดกของตนให้แก่ผู้ปกครอง
              หรือผู้ที่เกี่ยวข้องกับผู้ปกครองได้
            </li>
            <li>
              <mark className=" bg-[#fee9b2] rounded-xl">
                ห้ามบุคคลผู้เป็น ผู้เขียน หรือ พยาน
                ในพินัยกรรมรับทรัพย์มรดกตามที่พินัยกรรมได้ระบุไว้
              </mark>{" "}
              ซึ่งผู้เขียน หรือ พยาน นั้นเป็นใครก็ได้
              แต่ไม่สามารถรับทรัพย์มรดกตามพินัยกรรมที่เขียนไว้ได้เท่านั้น
              แล้วถ้าในกรณีที่ สามีภรรยา เป็น ผู้เขียน หรือ พยาน
              และไม่ได้เป็นสามีภรรยาตามกฎหมาย
              ในกรณีนี้สามารถรับทรัพย์มรดกตามพินัยกรรมได้
            </li>
          </ul>
        </p>
      </div>

      <div>
        <h1 className="ml-4">แนะนำสำหรับคุณ</h1>
        <ul className="list__post">
          <li>
            <a className="text-indigo-700 underline" href="/thai/1">
              ทายาทในกองมรดกสามารถเป็นใครได้บ้าง ?
            </a>
          </li>
          <li>
            <a className="text-indigo-700 underline" href="/thai/6">
              รูปแบบพินัยกรรมของพินัยกรรม
            </a>
          </li>
          <li>
            <a className="text-indigo-700 underline" href="/thai/7">
              ความสามารถของผู้ทำพินัยกรรม
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default ผู้รับพินัยกรรม;
